import React from 'react';
import { Route, Switch } from 'react-router-dom';
import List from 'components/Loans/List';
import LoanScheduleReminder from 'components/Loans/LoanScheduleReminder';
import Loan from 'components/Loans/Loan';

export default class Loans extends React.Component {
  render = () => {
    const { match } = this.props;
    return (
      <div>
        <Switch>
          <Route exact path='/loans' component={List}/>
          <Route path={`${match.url}/:loanNumber`} component={Loan}/>
          <Route exact path='/loan_schedule_reminder' component={LoanScheduleReminder}/>
        </Switch>
      </div>
    );
  };
}



// WEBPACK FOOTER //
// ./src/components/Loans/index.js